import GoogleAnalytics from "./googleAnalytics.service";

const googleAnalyticsModule = angular
  .module("app.services.googleAnalytics", [])
  .service("GoogleAnalytics", GoogleAnalytics);

export default googleAnalyticsModule;



// WEBPACK FOOTER //
// ./src/services/googleAnalytics/googleAnalytics.module.js